/**
 * Axios instance preset
 */
// Dependencies
import axios from 'axios';

// Settings
const protocol = 'https://';
const host = 'pagos.zapopan.gob.mx/WSPagoEnLineaJEO';
// const host = 'pagos.zapopan.gob.mx/WSPagoEnLinea';
// const host = 'pruebasigob.zapopan.gob.mx/WSPagoEnLineaTest';
// const host = 'pagos.zapopan.gob.mx/WSPagoEnLineaTest';
const path = '/api';
const timeout = 900000;

// Vars
export const originalURL = `${protocol}${host}`;
export const baseURL = `${originalURL}${path}`;

const http = axios.create({
  baseURL,
  timeout,
});

export default http;
